import * as React from 'react';
import { SVGProps } from 'react';

const IconBagSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2h3a2 2 0 0 1 2 2v1l-9.758 2.909a1 1 0 0 1-.485 0L2 10V9a2 2 0 0 1 2-2h3V5zm8 0H9v2h6V5z"
    />
    <path d="m22 12-9.272 2.849a3 3 0 0 1-1.456 0L2 12v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-7z" />
  </svg>
);
export default IconBagSizeM;
